module.exports = __webpack_public_path__ + "static/media/robot-field-of-corn-1.436fc555.jpg";